import * as React from "react";
import { connect } from "react-redux";
import Login from "../../screens/Login";
import { login } from "./actions";
export interface Props {
  logins: any;
}

export interface State {}
class LoginSection extends React.Component<Props, State> {
  render() {
    return (
      <Login
        logins={this.props.logins}
        logoutaction={this.props.logoutaction}
        loginLoader={this.props.loginLoader}
      />
    );
  }
}
function bindAction(dispatch) {
  return {
    logins: (value) => {
      dispatch(login(value));
    },
  };
}

const mapStateToProps = (state) => {
  return {
    ...state.logInReducer,
  };
};

export default connect(mapStateToProps, bindAction)(LoginSection);
